var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D7192D",
    stroke: "none",
    pid: 0,
    d: "M6.546 17.99l.06-3.766c.1-.444.428-.833.876-.887l6.823-1.047c1.324-.156 1.328-.408 0-.562l-6.823-1.052c-.442-.052-.778-.44-.876-.887l-.062-3.792c-.195-.878.283-1.247 1.07-.82L18.9 11.24c.786.425.787 1.113 0 1.54L7.613 18.825c-.784.424-1.262.05-1.067-.834v-.001z",
    _fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.svg";
export { ForwardRef as ReactComponent };